export interface ImplantGateInputs {
  canWrite: boolean;
  vetId: string | null | undefined;
  techId: string | null | undefined;
  cl: string | null | undefined;
  isPregnant: boolean;
  estrusSync: number | string | null | undefined;
}

const ES_MIN = 5.5;
const ES_MAX = 9.5;

export function isEstrusSyncOutOfRange(
  es: number | string | null | undefined,
): boolean {
  if (es === null || es === undefined || es === '') return false;
  const value = typeof es === 'string' ? parseFloat(es) : es;
  if (isNaN(value)) return false;
  return value <= ES_MIN || value >= ES_MAX;
}

export function getImplantBlockedReason(
  input: ImplantGateInputs,
): string | null {
  if (!input.canWrite) return 'You lack CHUTE_IMPLANT.WRITE permission';
  if (!input.vetId) return 'Vet not selected on toolbar';
  if (!input.techId) return 'Tech not selected on toolbar';
  if (!input.cl) return 'Select a CL side first';
  if (input.isPregnant) return 'Recipient is already Pregnant';
  if (isEstrusSyncOutOfRange(input.estrusSync))
    return 'ES value is outside the allowed implant range (must be > 5.5 and < 9.5)';
  return null;
}
